/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { VbzButton, VbzModal } from '@smiles/voebiz-ui-kit';
import { ModalBody } from 'reactstrap';

export type ModalT = {
  isOpen: boolean;
  title: string;
  description: string;
  buttonText: string;
  redirectUrl?: string | undefined;
  handleOnClick: () => void;
  handleOnClose?: () => void | undefined;
  toggle?: () => void | undefined;
};

const Modal = ({
  isOpen,
  title,
  description,
  buttonText,
  redirectUrl,
  handleOnClick,
  handleOnClose,
  toggle,
}: ModalT) => {
  return (
    <VbzModal isOpen={isOpen} onClosed={handleOnClose} toggle={toggle}>
      <ModalBody>
        <h4>{title}</h4>
        <p className="matac_modal_description">{description}</p>
        <div className="matac_modal_wrapper">
          <VbzButton text={buttonText} onClick={handleOnClick} />
          {redirectUrl && <a href={redirectUrl}>Acompanhar solicitações</a>}
        </div>
      </ModalBody>
    </VbzModal>
  );
};

export default Modal;

Modal.defaultProps = {
  redirectUrl: undefined,
  handleOnClose: undefined,
  toggle: undefined,
};
